import { Card, CardActionArea, CardContent, Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useStyles } from "./styles"
import { colors } from '../../colors';
function EquipmentList({ equipments }) {
  const classes = useStyles();
  let history = useHistory();
  
  function labelColor(label) {
    switch (label) {
      case "Público":
        return colors.public;
      case "Privado":
        return colors.private;
      default:
        return colors.default;
    }
  }

  function handleChangePage(id) {
    history.push(`${history.location.pathname}/${id}`)
  }
  return(
    <>
      {equipments.map(eqp => {
        return(
          <Card 
            key={eqp.ID}
            className={classes.card} 
            onClick={() => handleChangePage(eqp.ID)}
          >
            <CardActionArea>
              <CardContent>
                <Typography 
                  variant="h2" 
                  color="textPrimary" 
                  className={classes.equipment}
                >
                  {eqp.Nome}
                </Typography>
                <Typography variant="body1" className={classes.info}>
                  Mais informações
                </Typography>
                {eqp.NATUREZA_JURIDICA && (
                  <Card className={classes.label} style={{backgroundColor: labelColor(eqp.NATUREZA_JURIDICA)}}>
                    <CardContent>
                      <Typography>
                        {eqp.NATUREZA_JURIDICA.substring(0,10)}
                      </Typography>
                    </CardContent>
                  </Card>
                )}
              </CardContent>
            </CardActionArea>
          </Card>
        )
      })}
    </>
  );
}

export default EquipmentList;